import { useMutation } from '@tanstack/react-query';
import type { FileUploadCleanupRequest, FileUploadCleanupPreviewResponse } from '../../../Domain/Admin/Services';
import { adminServices } from '../../../Domain/Admin/Services';

const mutationFn = async (data: FileUploadCleanupRequest): Promise<FileUploadCleanupPreviewResponse> => {
  const response = await adminServices.undoUploadedFilePreview(data);
  return response.data;
};

export const useFileUploadCleanupPreviewMutation = () => {
  return useMutation<FileUploadCleanupPreviewResponse, unknown, FileUploadCleanupRequest>(mutationFn);
};
